import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {getCourseDurationString} from '../../../../../utils/entity/course';
import {isDefined} from '../../../../../utils/typecheck';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, course, program} = contexts;

  const courseDates = getCourseDurationString(course);
  const hasCourseStartDate = isDefined(course?.start_date);

  const isIndividual = !!course?.client_id;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    subAvatar: actor?.avatar,
    subAvatarPlaceholder: actor?.name,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:membership_created.title.course.individual')
       * t('notifications:membership_created.title.course.group')
       * t('notifications:membership_created.title.program')
       * t('notifications:membership_accepted.title.course.individual')
       * t('notifications:membership_accepted.title.course.group')
       * t('notifications:membership_accepted.title.program')
       * t('notifications:membership_requested.title.course.individual')
       * t('notifications:membership_requested.title.course.group')
       * t('notifications:membership_requested.title.program')
       */
      i18n.t(
        `notifications:${event.type}.title.${
          courseDates
            ? `course.${isIndividual ? 'individual' : 'group'}`
            : 'program'
        }`,
        {
          actorName: actor?.name,
          courseDates:
            hasCourseStartDate && courseDates ? `(${courseDates})` : '',
          programTitle: program?.title,
        },
      ),
  };
};
